import React, { useEffect, useState } from "react";
import axios, { authIsValid } from "../axios";
import { useCookies } from "react-cookie";
import Formula from "../components/Formula";
import MyLists from "../components/MyLists";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import Glogo from "../components/Glogo";

function Lists() {
  const [myFormulas, setMyFormulas] = useState([]);
  const [cookies, setCookies] = useCookies();
  const [selectedFormula, setSelectedFormula] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleDeleteFormula = async (e) => {
    try {
      const response = await axios.put(
        "/users/deleteFormula",
        { formulaId: e.target.id },
        { headers: { "x-access-token": cookies.access_token } }
      );
      if (response.data.message) {
        if (authIsValid(response.data.message) === false) {
          navigate("/mixer");
        } else {
          alert(response.data.message);
        }
      } else {
        const updatedList = myFormulas.filter(
          (formula) => formula._id !== e.target.id
        );
        setMyFormulas([...updatedList]);
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleViewFormula = (e) => {
    const formulaToView = myFormulas.find(
      (formula) => formula._id === e.target.id
    );
    setSelectedFormula(formulaToView);
  };

  useEffect(() => {
    const fetchFormulas = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`/users/myFormulas`, {
          headers: { "x-access-token": cookies.access_token },
        });
        if (response.data.message) {
          if (authIsValid(response.data.message) === false) {
            navigate("/mixer");
          } else {
            alert(response.data.message);
          }
        } else {
          //console.log(response.data);
          setMyFormulas(response.data);
        }
      } catch (err) {
        console.log(`Error: ${err.message}`);
      }
      setIsLoading(false);
    };
    fetchFormulas();
  }, []);

  return (
    <>
      <div className="adminHeader col-12 no-print">
        <h5>My Lists</h5>
      </div>
      <div id="listsWrapper" className="row col-12 justify-content-center">
        <div id="myFormulasContainer" className="col-10">
          <h5
            className="no-print futuraBold"
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            My Formulas
          </h5>
          <div className="row col-12">
            <div className="col-md-6 no-print" style={{ position: "relative" }}>
              {isLoading && <Loader />}
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th style={{ paddingLeft: 20 }}>Swatch</th>
                    <th>Name</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {myFormulas[0] !== null &&
                    myFormulas.map((formula) => {
                      return (
                        <tr key={formula._id}>
                          <td>
                            <Glogo
                              hasStroke={true}
                              size="md"
                              color={formula.color.hex}
                            />
                            {/*<span
                              className="formulasSwatch"
                              style={
                                formula.color !== undefined
                                  ? { backgroundColor: formula.color.hex }
                                  : { backgroundColor: "white" }
                              }
                            ></span>*/}
                          </td>
                          <td>{formula.color.name}</td>
                          <td align="right">
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "flex-end",
                                rowGap: 15,
                              }}
                            >
                              <button
                                id={formula._id}
                                className="btn btn-sm deleteFormulaButton"
                                onClick={handleDeleteFormula}
                              >
                                Delete
                              </button>
                              <button
                                id={formula._id}
                                className="editMyFormulaBtn btn btn-sm"
                                onClick={(e) =>
                                  navigate("/editFormula", {
                                    state: {
                                      formulaId: e.target.id,
                                      personalFormula: true,
                                    },
                                  })
                                }
                              >
                                Edit
                              </button>
                              <button
                                id={formula._id}
                                className="viewMyFormulaBtn btn btn-sm"
                                style={{ marginLeft: "15px" }}
                                onClick={handleViewFormula}
                              >
                                View&nbsp;<span>&#10095;</span>
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div
              className="col-md-6"
              style={{ position: "relative", minHeight: "128px" }}
            >
              {selectedFormula && (
                <p
                  className="closeViewFormula no-print"
                  onClick={() => setSelectedFormula(null)}
                >
                  X
                </p>
              )}
              <Formula
                formula={selectedFormula}
                multiplier={1000}
                isMyFormula={true}
              />
            </div>
          </div>
        </div>
      </div>
      <div style={{ height: "30px" }}></div>
      <hr className="no-print" />
      <MyLists access_token={cookies.access_token} />
    </>
  );
}

export default Lists;
